// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"34ba2f2d","732":"6dc083fb","977":"e859577e"}[chunkId] + ".chunk.js";
};